module.exports = __webpack_public_path__ + "assets/media/evening.42e784cc.mp3";